"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IndicatorState = void 0;
const ui_1 = require("@jsonjoy.com/ui");
const slate_react_1 = require("slate-react");
const GAP = 4;
/**
 * State for the autoformat/caret indicator: a small, unobtrusive pill anchored
 * near the caret used to surface what an autoformat rule is about to do.
 */
class IndicatorState {
    constructor(mutxt) {
        this.mutxt = mutxt;
        /** What is currently being shown, or `null` when hidden. */
        this.shown = ui_1.rsync.val(null);
        /**
         * Show the indicator near the current caret. Returns a dismiss function
         * scoped to this specific call: calling it after a different `show()`
         * has run is a no-op.
         */
        this.show = (content) => {
            this.shown.next(content);
            return () => {
                if (this.shown.value === content)
                    this.shown.next(null);
            };
        };
        /** Force-hide whatever is currently showing. */
        this.dismiss = () => {
            this.shown.next(null);
        };
    }
    start() {
        return () => {
            this.shown.next(null);
        };
    }
    anchorPoint() {
        const mutxt = this.mutxt;
        const sel = mutxt.editor.selection;
        if (!sel)
            return;
        try {
            const domRange = slate_react_1.ReactEditor.toDOMRange(mutxt.editor, sel);
            const caretRect = this.getFocusCaretRect() ?? domRange.getBoundingClientRect();
            if (!caretRect.width && !caretRect.height && !caretRect.top && !caretRect.left)
                return;
            const x = caretRect.left;
            const spaceAbove = caretRect.top;
            if (spaceAbove >= 28)
                return { x, y: caretRect.top - GAP, dx: 1, dy: -1 };
            return { x, y: caretRect.bottom + GAP, dx: 1, dy: 1 };
        }
        catch {
            return;
        }
    }
    getFocusCaretRect() {
        const sel = typeof window !== 'undefined' ? window.getSelection() : null;
        if (!sel?.focusNode)
            return null;
        try {
            const range = document.createRange();
            range.setStart(sel.focusNode, sel.focusOffset);
            range.collapse(true);
            const rect = range.getClientRects()[0] ?? range.getBoundingClientRect();
            if (rect.width > 0 || rect.height > 0)
                return rect;
            return null;
        }
        catch {
            return null;
        }
    }
}
exports.IndicatorState = IndicatorState;
